import { lazy } from 'react';
import { useParams } from 'react-router';
import type { TransparencyReportingAuthorization } from 'src/apis/transparency-reporting/types';
import {
  JOB_RUN_DETAIL_URL,
  useJobRunDetail,
} from 'src/apis/transparency-reporting/use-job-run-detail';
import {
  JOB_RUN_DOWNLOAD_URL,
  useJobRunDownload,
} from 'src/apis/transparency-reporting/use-job-run-download';
import {
  JOB_RUN_RETRY_URL,
  useJobRunRetry,
} from 'src/apis/transparency-reporting/use-job-run-retry';
import { PageSpinner } from 'src/components/spinner-container';

const Page = lazy(() => import('./page'));

type Props = {
  authorization: TransparencyReportingAuthorization;
};

export const ReportsDetails = ({ authorization }: Props) => {
  const { id } = useParams<{ id: string }>();
  const reportId = Number.parseInt(id);

  const jobRunDetails = useJobRunDetail({
    jobRunDetailUrl: JOB_RUN_DETAIL_URL,
    id: reportId,
  });
  const jobRunDownload = useJobRunDownload({
    jobRunDownloadUrl: JOB_RUN_DOWNLOAD_URL,
  });
  const jobRunRetry = useJobRunRetry({ jobRunRetryUrl: JOB_RUN_RETRY_URL });

  if (!jobRunDetails.response) return <PageSpinner />;

  return (
    <Page
      reportId={reportId}
      authorization={authorization}
      jobRunDetails={jobRunDetails}
      jobRunDownload={jobRunDownload}
      jobRunRetry={jobRunRetry}
    />
  );
};
